module.exports = __webpack_public_path__ + "img/car2.4083daeb.png";